import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { M8AccountInfo } from 'services/production/types';
import { getM8UserURL } from 'services/production/utils/getM8URL';

export const getAccountInfo = async (): Promise<M8AccountInfo> => {
  const fetchURL = getM8UserURL('getAccountInfo');

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
